import { render, staticRenderFns } from "./ReportWidget.vue?vue&type=template&id=573b9216&scoped=true&"
import script from "./ReportWidget.vue?vue&type=script&lang=ts&"
export * from "./ReportWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ReportWidget.vue?vue&type=style&index=0&id=573b9216&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b9216",
  null
  
)

export default component.exports